module.exports = __webpack_public_path__ + "img/logo-dark.1c5cf9ad.svg";